export const campaignRouteParamNames = {
  campaignId: "campaignId",
  executionId: "executionId",
};

export const campaignRoutePaths = {
  create: "/campanhas/adicionar",
  edit: "/campanhas/:campaignId/editar",
  executionAnalysis: "/campanhas/execucoes/:campaignId/analise/:executionId",
  executions: "/campanhas/execucoes/:campaignId",
  list: "/campanhas",
};

function encodeCampaignId(campaignId) {
  return encodeURIComponent(String(campaignId || "").trim());
}

export function buildCampaignExecutionsPath(campaignId) {
  const encodedCampaignId = encodeCampaignId(campaignId);
  return encodedCampaignId
    ? `/campanhas/execucoes/${encodedCampaignId}`
    : campaignRoutePaths.list;
}

export function buildCampaignExecutionAnalysisPath(
  campaignId,
  executionId,
  { executionDate } = {},
) {
  const encodedCampaignId = encodeCampaignId(campaignId);
  const encodedExecutionId = encodeCampaignId(executionId);

  if (!encodedCampaignId || !encodedExecutionId) {
    return buildCampaignExecutionsPath(campaignId);
  }

  const query = executionDate ? `?execution_date=${encodeURIComponent(executionDate)}` : "";
  return `/campanhas/execucoes/${encodedCampaignId}/analise/${encodedExecutionId}${query}`;
}

export function buildCampaignEditPath(campaignId) {
  const encodedCampaignId = encodeCampaignId(campaignId);
  return encodedCampaignId
    ? `/campanhas/${encodedCampaignId}/editar`
    : campaignRoutePaths.list;
}
